export default __webpack_public_path__ + "static/media/landing_section_img_1.4d54aa06.png";